import React, {useState} from 'react';
import Customer from '../../../types/Customer';
import Button from '../../button';
import {getAttributeValue} from "../../../lib/attribute";
import InputField from "../../input-field";
import useUserNoteUpdate from "../../../hooks/use-user-note-update";

interface Props {
  customer: Customer;
}

const AdminUserNoteForm: React.FC<Props> = ({ customer }) => {
  const [note, setNote] = useState(
    getAttributeValue(customer.attributes, 'note')
  );

  const [updating, setUpdating] = useState(false);
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const update = useUserNoteUpdate(() => {
    setUpdating(false);
    setMessage('Updated successfully');
  }, () => {
    setUpdating(false);
    setErrorMessage('Update failed');
  });

  const onClick = () => {
    setUpdating(true);
    setMessage('');
    setErrorMessage('');
    update(customer.id, note);
  };

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
    }}>
      <h2>User Note</h2>
      <div className="user-note">
        <InputField
          id="note"
          label=""
          type="text"
          width="100%"
          multiline={true}
          defaultValue={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </div>
      {updating
        ? <p>Updating...</p>
        : <>
          <Button text="Save" onClick={onClick}/>
          {message && <p style={{ marginTop: "14px" }}>{message}</p>}
          {errorMessage && <p style={{ marginTop: "14px", color: "red" }}>{errorMessage}</p>}
        </>}
      {/* language=CSS */}
      <style jsx>{`
        .user-note {
          width: 75%;
        }
      `}</style>
    </form>
  );
};

export default AdminUserNoteForm;
